import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import apiUrl from "../../Apiurl";

function renderData(data) {
  if (!data) return null;
  return (
    <pre className="ma0 pa3 code ws-pre overflow-auto bg-near-white">
      {JSON.stringify(data, null, 2)}
    </pre>
  );
}

function LogisticaAutomationRulesPage({ utente }) {
  const { getAccessTokenSilently, user } = useAuth0();
  const [snapshot, setSnapshot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const canDebug = Boolean(utente?.permessiAPI?.["read:debug"]);

  useEffect(() => {
    let ignore = false;

    const loadRules = async () => {
      if (!canDebug) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError("");
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(
          `${apiUrl}/manutenzione/logistica-automation-rules`,
          { headers: { Authorization: `Bearer ${accessToken}` } },
        );

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        if (!ignore) setSnapshot(data);
      } catch (loadError) {
        if (!ignore) setError(`Regole non caricate: ${loadError.message}`);
      } finally {
        if (!ignore) setLoading(false);
      }
    };

    loadRules();
    return () => {
      ignore = true;
    };
  }, [canDebug, getAccessTokenSilently, user?.sub]);

  if (!canDebug) {
    return (
      <div className="pa2 pa3-ns">
        <div className="sfondoBiancoTema br3 pa3">
          <h3 className="mt0 mb2">Regole automatismi logistica</h3>
          <p className="mb0 dark-red">Non hai i permessi per visualizzare questa pagina.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pa2 pa3-ns">
      <div className="mw9 center sfondoBiancoTema br3 pa3 pa4-l">
        <div className="mb4">
          <h1 className="mt0 mb2">Regole automatismi logistica</h1>
          {snapshot?.generatedAt && (
            <p className="mt0 mb0 dark-gray">
              Rilevate: {new Date(snapshot.generatedAt).toLocaleString()}
            </p>
          )}
        </div>

        {loading && <div className="pa3 ba b--black-20 br2">Caricamento...</div>}
        {error && <div className="pa3 ba b--dark-red dark-red br2">{error}</div>}

        {!loading && !error && snapshot && (
          <div>
            {snapshot.sections.map((section) => (
              <section key={section.id} className="mb4">
                <h2 className="mt0 mb3">{section.title}</h2>
                {section.rules.map((rule) => (
                  <div key={rule.name} className="ba b--black-10 br2 pa3 mb3">
                    <h3 className="mt0 mb2">{rule.name}</h3>
                    <ul className="mt0 mb3 pl4">
                      {rule.details.map((detail) => (
                        <li key={detail} className="mb2 lh-copy">{detail}</li>
                      ))}
                    </ul>
                    {renderData(rule.data)}
                  </div>
                ))}
              </section>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default LogisticaAutomationRulesPage;
